import { Input, Modal, Form, Select, Checkbox, Divider, Alert } from "antd";
import { useEffect, useState } from "react";
import { Button } from "../../misc/button/Button";
import { getEmailRules, getRequiredTextRules } from "../../helper-function/validationRules";
import AccountingFirmActivitySelect from "../../misc/AccountingFirmActivitySelect";

const EditUserModal = (props) => {
  const { open, onCancel, onEdit, record, laborUnionOption, isClaimed } = props;

  const [form] = Form.useForm();
  const { Option } = Select;
  const [declarantType, setDeclarantType] = useState('INTERNAL');

  useEffect(() => {
    if (!record) return;

    form.resetFields();
    form.setFieldsValue(record);

    // Initialiser les states pour les sections conditionnelles
    if (record.declarantType) {
      setDeclarantType(record.declarantType);
    } else {
      setDeclarantType('INTERNAL'); // Valeur par défaut
    }
  }, [form, record]);

  const handleDeclarantTypeChange = (value) => {
    setDeclarantType(value);
    if (value === 'INTERNAL') {
      // Vider les champs cabinet
      form.setFieldsValue({
        accountingFirmName: '',
        accountingFirmActivity: '',
        accountingFirmAddress: '',
        accountingFirmZipcode: '',
        accountingFirmCity: '',
      });
    }
  };

  const handleSave = (data) => {
    form
      .validateFields()
      .then((values) => {
        const formData = {
          ...values,
          id: record.id,
          membershipCode: record.membershipCode,
        };
        onEdit(formData, isClaimed);
      })
      .catch((info) => {
        console.error("Validate Failed:", info);
      });
  };

  return (
    <Modal
      forceRender
      title="Modification d'utilisateur"
      open={open}
      closable={false}
      footer={
        <div
          style={{
            marginRight: "10px",
            display: "flex",
            gap: "30px",
            justifyContent: "end",
          }}
        >
          <Button onClick={onCancel} children="Annuler" />
          <Button onClick={handleSave} children="Enregistrer" />
        </div>
      }
    >
      <Form className="edit-user-modal" form={form} initialValues={record} autoComplete="off">
        {/* Section 1 : Champs Admin-Only */}
        <Divider orientation="left">Informations Administratives</Divider>
        <Form.Item name="isActive" label="Entreprise active" valuePropName="checked">
          <Checkbox />
        </Form.Item>
        <Form.Item name="companyStatus" label="Statut de l'entreprise" rules={getRequiredTextRules("Le statut de l'entreprise adhérente")}>
          <Input />
        </Form.Item>
        <Form.Item name="naf" label="NAF">
          <Input />
        </Form.Item>
        <Form.Item name="companyName" label="Raison Sociale" rules={getRequiredTextRules("La raison sociale")}>
          <Input />
        </Form.Item>

        {/* Section 2 : Adresse Entreprise */}
        <Divider orientation="left">Adresse de l'Adhérent</Divider>
        <Form.Item name="address1" label="Adresse 1">
          <Input autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="address2" label="Adresse 2">
          <Input autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="address3" label="Adresse 3">
          <Input autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="address4" label="Ref Client">
          <Input autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="zipcode" label="Code postal">
          <Input autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="city" label="Commune">
          <Input autoComplete="new-password" />
        </Form.Item>

        {/* Section 3 : Métier et Adhésion — uniquement si claimed */}
        {isClaimed && (
          <>
            <Divider orientation="left">Métier et Adhésion</Divider>
            <Form.Item name="workForce" label="Effectifs" className="workForce" rules={[{ required: true, message: "Veuillez sélectionner les effectifs" }]}>
              <Select style={{ width: 120 }}>
                <Option value="upTo10">Jusqu'à 10</Option>
                <Option value="moreThan10">Plus de 10</Option>
              </Select>
            </Form.Item>
            <Form.Item name="laborUnion" label="Adhérent" className="laborUnion" rules={[{ required: true, message: "Veuillez sélectionner un adhérent" }]}>
              <Select style={{ width: 120 }}>
                {laborUnionOption.map((el, index) => (
                  <Option key={index} value={el.value}>
                    {el.text}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="buildingConventionOutside77"
              label="Convention Bâtiment hors 77"
              valuePropName="checked"
              className="checkbox"
            >
              <Checkbox />
            </Form.Item>
          </>
        )}

        {/* Section 4 : Représentant Légal — uniquement si claimed */}
        {isClaimed && (
          <>
            <Divider orientation="left">Représentant Légal</Divider>
            <Form.Item name="representativeFirstname" label="Prénom">
              <Input />
            </Form.Item>
            <Form.Item name="representativeLastname" label="Nom">
              <Input />
            </Form.Item>
            <Form.Item name="representativeFunction" label="Fonction">
              <Input />
            </Form.Item>
            <Form.Item name="representativePhone" label="Téléphone">
              <Input />
            </Form.Item>
            <Form.Item name="representativeEmail" label="Email" rules={getEmailRules(false)}>
              <Input type="email" />
            </Form.Item>
          </>
        )}

        {/* Section 5 : Référent APAS — uniquement si claimed */}
        {isClaimed && (
          <>
            <Divider orientation="left">Référent APAS</Divider>
            <Form.Item name="referentApasLastname" label="Nom du référent APAS">
              <Input />
            </Form.Item>
            <Form.Item name="referentApasFirstname" label="Prénom du référent APAS">
              <Input />
            </Form.Item>
            <Form.Item name="referentApasEmail" label="Email du référent APAS" rules={getEmailRules(false)}>
              <Input type="email" />
            </Form.Item>
          </>
        )}


        {/* Section 6 : Informations Déclarant — uniquement si claimed */}
        {isClaimed && (
          <>
            <Divider orientation="left">Informations Déclarant</Divider>
            <Form.Item name="declarantLastname" label="Nom du déclarant">
              <Input />
            </Form.Item>
            <Form.Item name="declarantFirstname" label="Prénom du déclarant">
              <Input />
            </Form.Item>
            <Form.Item name="declarantFunction" label="Fonction du déclarant">
              <Input />
            </Form.Item>
            <Form.Item name="declarantPhone" label="Téléphone du déclarant">
              <Input />
            </Form.Item>
            <Form.Item name="declarantType" label="Type de déclarant">
              <Select
                style={{ width: 200 }}
                onChange={handleDeclarantTypeChange}
              >
                <Option value="INTERNAL">Interne</Option>
                <Option value="EXTERNAL">Externe</Option>
              </Select>
            </Form.Item>
          </>
        )}

        {/* Section 7 : Cabinet Comptable — uniquement si claimed ET EXTERNAL */}
        {isClaimed && declarantType === 'EXTERNAL' && (
          <>
            <Divider orientation="left">Prestataire externe</Divider>
            <Form.Item name="accountingFirmName" label="Nom du prestataire externe">
              <Input autoComplete="new-password" />
            </Form.Item>
            <Form.Item name="accountingFirmActivity" label="Activité du prestataire externe">
              <AccountingFirmActivitySelect />
            </Form.Item>
            <Form.Item name="accountingFirmAddress" label="Adresse du prestataire">
              <Input autoComplete="new-password" />
            </Form.Item>
            <Form.Item name="accountingFirmZipcode" label="Code postal du prestataire">
              <Input maxLength={5} autoComplete="new-password" />
            </Form.Item>
            <Form.Item name="accountingFirmCity" label="Ville du prestataire">
              <Input autoComplete="new-password" />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default EditUserModal;
